import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Market from '../views/Market.vue'
import Profile from '../views/Profile.vue'
import Back from '../views/Back.vue'
import WeaponDetail from '../views/WeaponDetail.vue'
import BackProcess from '../views/BackProcess.vue'
import Wallet from '../views/Wallet.vue'
import Paypage from '../views/Paypage.vue'
import Stock from '../views/Stock.vue'
import Chat from '../views/Chat.vue'
import ProxyPlay from '../views/ProxyPlay.vue'
import ProxyPlayHistory from '../views/ProxyPlayHistory.vue'
import PaymentHistory from '../views/PaymentHistory.vue'
import ZijinHistory from '../views/ZijinHistory.vue'
import StockOrBack from '../views/StockOrBack.vue'
import Message from '../views/Message.vue'
import MyInfo from '../views/MyInfo.vue'
import RegisterMerchant from '../views/Registermerchant.vue'
import UserAuth from '../views/UserAuth.vue'
import ShopHistory from '../views/ShopHistory.vue'
import SellHistory from '../views/SellHistory.vue'
import Cart from '../views/Cart.vue'
import PaymentResult from '../views/PaymentResult.vue'
import store from '../store/index'
import { showDialog, showToast } from 'vant'
const routes = [
  {
    path: '/',
    name: 'Home',
    // redirect: '/home',
    component: Home,
    meta: {
      keepAlive: true // 首页需要缓存
    }
  },
  {
    path: '/home',
    name: 'Home2',
    component: Home,
    meta: {
      keepAlive: true // 首页需要缓存
    }
  },
  {
    path: '/myInfo',
    name: 'MyInfo',
    component: MyInfo,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/registermerchant',
    name: 'RegisterMerchant',
    component: RegisterMerchant,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/userauth',
    name: 'UserAuth',
    component: UserAuth,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/market',
    name: 'Market',
    component: Market,
    meta: {
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      keepAlive: false // 个人中心需要缓存
    }
  },
  {
    path: '/back',
    name: 'Back',
    meta: {
      requiresAuth: true,
      keepAlive: false
    },
    component: Back
  },
  {
    path: '/stockOrBack',
    name: 'StockOrBack',
    meta: {
      requiresAuth: false
    },
    component: StockOrBack
  },
  {
    path: '/backProcess',
    name: 'BackProcess',
    component: BackProcess,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/weapon/:id',
    name: 'WeaponDetail',
    component: WeaponDetail,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: Wallet,
    meta: {
      keepAlive: false
    }
  },
   {
    path: '/paypage',
    name: 'Paypage',
    component: Paypage,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/stock',
    name: 'Stock',
    meta: {
      requiresAuth: true
    },
    component: Stock
  },
  {
    path: '/chat',
    name: 'Chat',
    component: Chat,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/proxyPlay',
    name: 'ProxyPlay',
    meta: {
      requiresAuth: true
    },
    component: ProxyPlay
  },
  {
    path: '/proxyPlayHistory',
    name: 'ProxyPlayHistory',
    component: ProxyPlayHistory,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/zijinHistory',
    name: 'ZijinHistory',
    component: ZijinHistory,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/shopHistory',
    name: 'ShopHistory',
    component: ShopHistory,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/sellHistory',
    name: 'SellHistory',
    component: SellHistory,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/paymentHistory',
    name: 'PaymentHistory',
    component: PaymentHistory,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/message',
    name: 'Message',
    component: Message,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart,
    meta: {
      keepAlive: false
    }
  }
  ,
  {
    path: '/payment-result',
    name: 'PaymentResult',
    component: PaymentResult,
    meta: { keepAlive: false }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.path === "/market" || to.path === "/home"|| to.path === "/weapon" || to.path === "/") {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        // 调用 user.js 里的 getUserInfo 方法（假设是 action，返回 Promise）
        let res = await store.dispatch("user/getUserInfo");
        if (res.code != 200) {
          showToast("用户信息获取失败，请重新登录");
          localStorage.removeItem("token");
          next("/profile");
        }
      } catch (error) {
        // 获取用户信息失败，跳转登录页
        showToast("用户信息获取失败，请重新登录");
        localStorage.removeItem("token");
        next("/profile");
      }
    }
    next();
  } else {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        // 调用 user.js 里的 getUserInfo 方法（假设是 action，返回 Promise）
        let res = await store.dispatch("user/getUserInfo");
        if (res.code != 200) {
          showToast("用户信息获取失败，请重新登录");
          localStorage.removeItem("token");
          next("/profile");
        }
        next();
      } catch (error) {
        // 获取用户信息失败，跳转登录页
        showToast("用户信息获取失败，请重新登录");
        localStorage.removeItem("token");
        next("/home");
      }
    } else {
      if (to.meta.requiresAuth || to.path === '/user/playBack') {
        showToast("请先登录");
        next("/profile");
      } else {
        next();
      }
    }
  }
});

export default router